import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { workspaceSchema } from '../models/workspace.schema';
import { workspaceListQuerySchema } from './list.schema';

export type WorkspaceListQuery = Partial<{
  fields: string[];
  id: number[];
  ordering: string[];
  name: string;
}> &
  PaginationQuery;

export const list = (query: WorkspaceListQuery = {}) => {
  return {
    endpoint: `/workspaces`,
    method: 'GET',
    responseSchema: listResponse(workspaceSchema),
    query: { ...query, includeTotal: true },
    querySchema: workspaceListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
